<template>
    <div>
        <m-assembly-table
            ref="pageForm"
            :formData='formData'
            :columns="columns"
            :data="tableData"
            :tableButtons="tableButtons"
            :loading="loading"
            :currentPage="settings.currentPage"
            :pageSize="settings.pageSize"
            :total="settings.total"
            :settings="settings"
            thDrag
            @onSubmit='onSubmit'
            @onSelectionChange="onSelection"
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
        >
        </m-assembly-table>

        <!-- 失效报告 -->
        <Modal v-model="invalidModal.show"
               :title="$t('processInspectionSearch.t80')"
               :width="400"
               :mask-closable="false">
               <span style="font-size: 14px;">{{ $t('processInspectionSearch.t81') }}：</span><Input v-model="invalidModal.disableReason"></Input>
               <div slot="footer">
                   <Button type="primary" :loading="loading" @click="invalidReport">确定</Button>
               </div>
        </Modal>

        <!-- 已匹配送货单 -->
        <Modal v-model="matchModal.show"
               :title="$t('processInspectionSearch.t79')"
               :width="600"
               :mask-closable="false">
               <Table border
                      highlight-row
                      ref="matchTable"
                      :columns="matchModal.columns"
                      :data="matchModal.data"
                      :loading="loading"
                      size="small">
                </Table>
               <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved, import/extensions
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import axios from 'axios';
import processInspectionMixin from './processInspection';
import moment from 'moment';

export default {
    name: 'processInspectionSearch',
    components: {
        mAssemblyTable,
    },
    mixins: [processInspectionMixin],
    data() {
        return {
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('processInspectionSearch.t18'),
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('processInspectionSearch.t13'), // 库存组织
                        methods: {
                            change: (val) => {
                                this.selection = [];
                                this.tableData = [];
                            },
                        },
                    },
                    {
                        value: '',
                        field: 'poNumber',
                        placeholder: this.$t('createDeliveryOrderByOrder.t50'),
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t2'), // 采购订单号
                    },
                    {
                        value: '',
                        field: 'needByDateBegin',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     },
                        // },
                        style: 'width:100%',
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00',
                            options: {
                                disabledDate(date) {
                                    const dt = new Date();
                                    dt.setMonth(dt.getMonth() - 12);
                                    return date && date.valueOf() < dt - 86400000;
                                },
                            },
                        },
                        type: 'datePicker',
                        title: this.$t('processInspectionSearch.t8'), // 需求日期
                        placeholder: '',
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'needByDateEnd',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     }
                        // },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                    const dt = new Date();
                                    const dt2 = new Date();
                                    dt.setMonth(dt.getMonth() - 12);
                                    dt2.setMonth(dt2.getMonth() + 12);
                                    return date && (date.valueOf() < dt || date.valueOf() > dt2);
                                },
                            },
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                    },
                    {
                        value: '',
                        field: 'checkStatus',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.$t('processInspectionSearch.t70'),
                                    value: 'valid',
                                },
                                {
                                    label: this.$t('processInspectionSearch.t71'),
                                    value: 'invalid',
                                },
                            ],
                        },
                        type: 'select',
                        title: this.$t('processInspectionSearch.t14'), // 检验单状态
                    },
                    {
                        value: '',
                        field: 'reportNumberBegin',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t15'), // 检验单号
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'reportNumberEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                    },
                    {
                        value: moment().subtract('6', 'M').format('YYYY-MM-DD 00:00:00'),
                        field: 'checkDateBegin',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     },
                        // },
                        style: 'width:100%',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00',
                        },
                        type: 'datePicker',
                        title: this.$t('processInspectionSearch.t10'), // 检验日期
                        placeholder: ' ',
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: moment().format('YYYY-MM-DD 23:59:59'),
                        field: 'checkDateEnd',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     }
                        // },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                            },
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        placeholder: this.$t('createDeliveryOrderByOrder.t50'),
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t4'), // 物料编码
                    },
                    {
                        value: '',
                        field: 'checker',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t11'), // 检验员
                    },
                    {
                        value: '',
                        field: 'batchNo',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t33'), // 批次号
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 30,
                    },
                    {
                        title: this.$t('processInspectionSearch.t1'), // 检验
                        key: 'hasReport',
                        minWidth: 40,
                        align: 'center',
                        render: (h, params) => {
                            const { reportNumber } = params.row;
                            const disabled = !Boolean(reportNumber);
                            return h('Icon', {
                                props: {
                                    type: 'ios-circle-filled',
                                    size: 27,
                                    color: '#666',
                                },
                                style: {
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    color: disabled ? '#666' : '#2d8cf0',
                                },
                                nativeOn: {
                                    click: () => {
                                        if (!disabled) {
                                            const orgCode = this.getFormDataItemVal(this.formData.items, 'orgCode');
                                            const { itemUnit, poNumber, batchNo, checker, checkDate } = params.row;
                                            this.$router.push({
                                                name: 'processInspectionRead',
                                                query: {
                                                    reportNumber,
                                                },
                                                params: {
                                                    orgId: this.orgList.find((item) => item.organizationCode === orgCode).qmsId,
                                                    orgCode,
                                                    itemUnit,
                                                    poNumber,
                                                    batchNo,
                                                    checker,
                                                    checkDate,
                                                },
                                            });
                                        }
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('processInspectionSearch.t2'), // 采购订单号
                        key: 'poNumber',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('processInspectionSearch.t3'), // 采购单行号
                        key: 'poLineNumber',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('processInspectionSearch.t4'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('processInspectionSearch.t5'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('processInspectionSearch.t6'), // 单位
                        key: 'itemUnit',
                        align: 'center',
                        minWidth: 50,
                    },
                    {
                        title: this.$t('processInspectionSearch.t7'), // 订单数量
                        key: 'poQuantity',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t75'), // 可匹配数量
                        key: 'matchQuantity',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t23'), // 检验数量
                        key: 'checkQuantity',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t76'), // 剩余检验数量
                        key: 'remainQuantity',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t8'), // 需求日期
                        key: 'poNeedByDate',
                        align: 'center',
                        minWidth: 125,
                        render: (h, params) => {
                            const { poNeedByDate } = params.row;
                            return h('span', poNeedByDate ? moment(poNeedByDate).format('YYYY-MM-DD HH:mm:ss') : '');
                        },
                    },
                    {
                        title: this.$t('processInspectionSearch.t9'), // 检验单号
                        key: 'reportNumber',
                        align: 'center',
                        minWidth: 150,
                    },
                    {
                        title: this.$t('processInspectionSearch.t33'), // 批次号
                        key: 'batchNo',
                        align: 'center',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('processInspectionSearch.t10'), // 检验日期
                        key: 'checkDate',
                        align: 'center',
                        minWidth: 130,
                        render: (h, params) => {
                            const { checkDate } = params.row;
                            return h('span', checkDate ? moment(checkDate).format('YYYY-MM-DD HH:mm:ss') : '');
                        },
                    },
                    {
                        title: this.$t('processInspectionSearch.t11'), // 检验员
                        key: 'checker',
                        align: 'center',
                        minWidth: 80,
                    },
                    {
                        title: this.$t('processInspectionSearch.t14'), // 检验单状态
                        key: 'checkStatus',
                        align: 'center',
                        minWidth: 80,
                    },
                    {
                        title: this.$t('processInspectionSearch.t77'), // 失效日期
                        key: 'disableDate',
                        align: 'center',
                        minWidth: 130,
                        render: (h, params) => {
                            const { disableDate } = params.row;
                            return h('span', disableDate ? moment(disableDate).format('YYYY-MM-DD HH:mm:ss') : '');
                        },
                    },
                    {
                        title: this.$t('processInspectionSearch.t78'), // 失效原因
                        key: 'disableReason',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('processInspectionSearch.t79'), // 已匹配送货单
                        key: 'hasMatchDelivery',
                        minWidth: 50,
                        align: 'center',
                        render: (h, params) => {
                            const { hasMatchDelivery } = params.row;
                            const disabled = hasMatchDelivery !== 'Y';
                            return h('Icon', {
                                props: {
                                    type: 'ios-circle-filled',
                                    size: 27,
                                    color: '#666',
                                },
                                style: {
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    color: disabled ? '#666' : '#2d8cf0',
                                },
                                nativeOn: {
                                    click: () => {
                                        if (!disabled) {
                                            this.matchModal.show = true;
                                            this.queryDelivery(params.row.id);
                                        }
                                    },
                                },
                            });
                        },
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('processInspectionSearch.t72'), // 新增检验报告
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: () => {
                            // if (this.selection.filter((item) => !item.hasReport).length === 0) {
                            //     this.$Modal.warning({
                            //         content: this.$t('processInspectionSearch.t58'),
                            //     });
                            //     return false;
                            // }
                            // let itemCode = new Set();
                            // let batchQty = 0;
                            // let poLineIds = [];
                            // this.selection.forEach((item) => {
                            //     itemCode.add(item.itemCode);
                            //     batchQty += item.releasedQuantity;
                            //     poLineIds.push(item.poLineId);
                            // });
                            // if ([...itemCode].length > 1) {
                            //     this.$Modal.warning({
                            //         content: this.$t('processInspectionSearch.t59'),
                            //     });
                            //     return false;
                            // }

                            // this.$router.push({
                            //     name: 'processInspectionAdd',
                            //     query: {
                            //         itemCode: [...itemCode][0],
                            //         orgId: this.orgList.find((item) => item.organizationCode === this.getFormDataItemVal(this.formData.items, 'orgCode')).qmsId,
                            //         batchQty,
                            //         poLineIds: poLineIds.join(),
                            //     },
                            // });
                            // if (!this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                            //     return false;
                            // }
                            // this.$set(button, 'loading', true);
                            // this.exportExcel('/gscint/inspectionReport/exportHeader', {
                            //     ...this.getFormDataVModel(this.formData.items),
                            //     vendorCode: this.vendorCode,
                            // });
                            // setTimeout(() => {
                            //     this.$set(button, 'loading', false);
                            // }, 5000);
                            this.$router.push({
                                name: 'processInspectionAdd',
                                params: {
                                    orgCode: this.getFormDataItemVal(this.formData.items, 'orgCode'),
                                },
                            });
                        },
                    },
                    {
                        label: this.$t('processInspectionSearch.t17'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (!this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                return false;
                            }
                            this.$set(button, 'loading', true);
                            this.exportExcel('/gscint/inspectionReport/exportHeader', {
                                ...this.getFormDataVModel(this.formData.items),
                                vendorCode: this.vendorCode,
                                language: this.$i18n.locale,
                            });
                            setTimeout(() => {
                                this.$set(button, 'loading', false);
                            }, 5000);
                        },
                    },
                    {
                        label: this.$t('processInspectionSearch.t73'), // 失效单据
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        size: 'small',
                        click: (button) => {
                            /*  仅可对未失效且采购订单状态为"valid"的单据进行失效，否则提示“检验单号【XXXX】已使用，禁止失效！”。 */
                            if (this.selection.find((item) => item.checkStatusCode !== 'valid' && item.hasMatchDelivery !== 'Y') || this.selection.length === 0) {
                                this.$Modal.warning({
                                    content: this.$t('processInspectionSearch.t87'), // 请勾选有效数据且未匹配的数据
                                });
                                return false;
                            }
                            this.invalidModal.show = true;
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
            },
            orgList: [],
            selection: [],
            invalidModal: {
                show: false,
                disableReason: '',
            },
            matchModal: {
                show: false,
                columns: [
                    {
                        title: this.$t('processInspectionSearch.t82'), // 送货单条码号
                        minWidth: 100,
                        key: 'barcodeNumber',
                        align: 'center',
                    },
                    {
                        title: this.$t('processInspectionSearch.t83'), // 送货单号
                        minWidth: 100,
                        key: 'deliveryNumber',
                        align: 'center',
                    },
                    {
                        title: this.$t('processInspectionSearch.t84'), // 送货单状态
                        minWidth: 70,
                        key: 'deliveryStatus',
                        align: 'center',
                    },
                    {
                        title: this.$t('processInspectionSearch.t85'), // 匹配数量
                        minWidth: 60,
                        key: 'matchCount',
                        align: 'center',
                    },
                    {
                        title: this.$t('processInspectionSearch.t86'), // 匹配时间
                        minWidth: 110,
                        align: 'right',
                        key: 'creationDate',
                    },
                ],
                data: [],
            },
        };
    },
    watch: {
        'invalidModal.show': function (newVal) {
            if (!newVal) {
                this.invalidModal.disableReason = '';
            }
        },
    },
    methods: {
        onSubmit() {
            this.settings.currentPage = 1;
            this.onSearch();
        },
        onSearch() {
            this.fromToValCheck();
            const formData = this.getFormDataVModel(this.formData.items);
            const { checkDateBegin, checkDateEnd, poNumber, itemCode } = formData;
            if (checkDateBegin && checkDateEnd) {
                if (moment(checkDateBegin).add(1, 'y').format('x') < moment(checkDateEnd).format('x') - 86400000) {
                    // 检验报告创建日期最大查询范围为1年，请修改！
                    this.$Modal.warning({
                        content: this.$t('processInspectionSearch.t117'),
                    });
                    return;
                }
            }
            if (poNumber && poNumber.split(',').length > 10) {
                this.$Modal.warning({
                    content: `${this.$t('processInspectionSearch.t118')}${this.$t('processInspectionSearch.t2')}`,
                });
                return;
            }
            if (itemCode && itemCode.split(',').length > 10) {
                this.$Modal.warning({
                    content: `${this.$t('processInspectionSearch.t118')}${this.$t('processInspectionSearch.t4')}`,
                });
                return;
            }
            this.loading = true;
            const { currentPage, pageSize } = this.settings;
            axios.post('/gscint/inspectionReport/queryHeaderPage', {
                vendorCode: this.vendorCode,
                language: this.$i18n.locale,
                pageNum: currentPage,
                pageSize,
                ...formData,
            })
                .then((res) => {
                    this.loading = false;
                    const { datas, code, msg } = res.data.data;
                    if (code === '1') {
                        this.tableData = datas.list;
                        this.settings.total = datas.total;
                    } else {
                        this.showErrorTips('loading', msg);
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSelection(selection) {
            this.selection = selection;
        },
        invalidReport() {
            const { disableReason } = this.invalidModal;
            if (!disableReason) {
                this.$Modal.warning({
                    content: this.$t('processInspectionSearch.t88'), // 请填写失效原因，否则禁止失效！
                });
            } else {
                let ids = [];
                this.selection.forEach((item) => ids.push(item.id));
                axios.post('/gscint/inspectionReport/disableHeader', {
                    ids: ids.join(),
                    disableReason,
                })
                    .then((res) => {
                        const { datas, msg } = res.data.data;
                        if (datas) {
                            this.$Modal.success({
                                content: this.$t('processInspectionSearch.t110'), // 失效成功
                            });
                            this.autoSearch();
                            this.invalidModal.show = false;
                        } else {
                            this.showErrorTips('loading', msg);
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    });
            }
        },
        queryDelivery(id) {
            this.loading = true;
            axios.get('/gscint/inspectionReport/queryDelivery', {
                params: {
                    id,
                },
            })
                .then((res) => {
                    this.loading = false;
                    const { datas, msg } = res.data.data;
                    if (datas) {
                        this.matchModal.data = datas;
                    } else {
                        this.showErrorTips('loading', msg);
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
        // getInvLovNew() {
        //     axios.get('/gscapp/lov/getInvLovNew', {
        //         params: {
        //             UP: 'Y',
        //             SITE: 'Y',
        //             ASL: 'N',
        //             labelName: 'organizationName',
        //             valueName: 'erpOrgId',
        //         },
        //     })
        //         .then((res) => {
        //             let data = res.data.data || [];
        //             data.forEach((item) => {
        //                 item.value = item.code;
        //             });
        //             this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = data;
        //         });
        // },
    },
    activated() {
        this.autoSearch();
    },
    mounted() {
    },
};
</script>
